import axios from 'axios'

export interface CupomDesconto {
  id: number
  descricao: string
  cupom_code: string // Novo campo adicionado

  pedidosCount?: number // Quantidade de pedidos já utilizados

  tipo: 'VALOR' | 'PORCENTAGEM' // Tipo de desconto
  valor: number | null // Valor de desconto
  porcentagem: number | null // Porcentagem de desconto
  quantidade_cupons?: number  // Quantidade de cupons disponíveis -1 para ilimitado
  valor_minimo_pedido?: number // Valor mínimo de compra para aplicar o cupom

  created_at: Date // Data criação
  data_inicio: Date // Data de início
  data_fim: Date // Data de fim
  data_expiracao?: Date // Data de expiração

  produto_ids: number[] // IDs dos produtos
  grupo_produtos_ids: number[] // IDs dos grupos de produtos
  filtro_todos_produtos: boolean // Se o cupom é para todos os produtos

  cliente_ids: number[] // IDs dos clientes
  perfil_cliente_ids: number[] // IDs dos perfis de clientes
  filtro_todos_clientes: boolean // Se o cupom é para todos os clientes
  filtro_primeiro_pedido: boolean // Se o cupom é para clientes novos

  usuario_criacao_id: number // ID do usuário criador
  situacao: 'ATIVO' | 'INATIVO' // Status do cupom

  descricao_publica: string // Nova propriedade
}

export type HistoricoCupom = {
  nroPedido: string | null;
  valorTotal: string;
  data: string;
  valorAplicadoCupom: number;
  user: {
    id: number;
    cliente: {
      id: number;
      fantasia: string;
    };
  };
}

class CupomService {

  async criarCupom(data: Omit<CupomDesconto, 'id' | 'created_at'>): Promise<CupomDesconto> {
    const response = await axios.post('/cupons', data)
    return response.data
  }

  async desativarCupom(id: number): Promise<void> {
    await axios.put(`/cupons/desativar/${id}`)
  }

  async atualizarCupom(id: number, cupomData: Partial<Omit<CupomDesconto, 'id' | 'created_at'>>): Promise<CupomDesconto> {
    const response = await axios.put(`/cupons/${id}`, cupomData)
    return response.data
  }

  async findOneCupom(id: number): Promise<CupomDesconto> {
    const response = await axios.get(`/cupons/${id}`)
    return response.data
  }

  async findAllCupons(page: number, itemsPerPage: number, search?: string): Promise<{ items: CupomDesconto[]; total: number }> {
    const params = {
      page,
      itemsPerPage,
      search
    }
    const response = await axios.get('/cupons', { params })
    return response.data
  }

  async validarCupom(data: { codigo: string; clienteId: number }): Promise<CupomDesconto> {
    const response = await axios.post('/cupons/validar', data)
    return response.data
  }

  async aplicarCupom(data: { codigo: string; pedidoId: number }): Promise<CupomDesconto> {
    const response = await axios.post('/cupons/aplicar', data)
    return response.data
  }

  async getHistoricoUso(id: number): Promise<HistoricoCupom[]> {
    const response = await axios.get(`/cupons/historico/${id}`)
    return response.data
  }

  async getCuponsByCliente(): Promise<{
    id: number,
    descricao: string,
    cupom_code: string,
    tipo: 'VALOR' | 'PORCENTAGEM',
    valor: number,
    porcentagem: number | null,
    valor_minimo_pedido: number
  }[]> {
    const response = await axios.get(`/cupons/cliente`)
    return response.data
  }

  async getCupomHistorico(id: number): Promise<{ items: HistoricoCupom[]; total: number }> {
    const response = await axios.get(`/cupons/historico/${id}`)
    return response.data
  }
}

export default new CupomService()
